import { Download, FileCode2 } from 'lucide-react';
import { useState } from 'react';

import { mensagemDeErro } from '@/lib/erros';
import { formatarBytes, formatarDataHora } from '@/lib/formato';
import { toast } from '@/ui/primitives/aviso';
import { Button } from '@/ui/primitives/button';
import { type DocumentoDetalhe } from '@fiscoai/contracts';

import { baixarXml } from './api';

export function AbaArquivos({ doc, podeBaixar }: { doc: DocumentoDetalhe; podeBaixar: boolean }) {
  const [baixando, setBaixando] = useState(false);
  const baixar = () => {
    setBaixando(true);
    baixarXml(doc.id, doc.chave)
      .catch((erro: unknown) => toast.error(mensagemDeErro(erro)))
      .finally(() => {
        setBaixando(false);
      });
  };
  return (
    <div className="grid gap-4">
      <ul className="divide-y divide-borda rounded-cartao border border-borda">
        {doc.arquivos.map((a) => (
          <li key={a.id} className="flex items-center gap-3 px-4 py-3">
            <FileCode2 className="size-5 text-marca" aria-hidden />
            <div className="grid min-w-0 flex-1 gap-0.5">
              <span className="truncate font-medium">{a.nomeOriginal}</span>
              <span className="text-xs text-texto-fraco">
                {formatarBytes(a.tamanho)}, recebido em {formatarDataHora(a.recebidoEm)}
              </span>
            </div>
          </li>
        ))}
      </ul>
      {podeBaixar && (
        <Button
          variante="primario"
          onClick={baixar}
          carregando={baixando}
          className="justify-self-start"
        >
          <Download aria-hidden />
          Baixar XML original
        </Button>
      )}
    </div>
  );
}
